import type { ExecutionSearchSummary } from '@src/models/interfaces/execution.interface';
import type { ScheduleSearchSummary } from '@src/models/interfaces/schedule.interface';
import { formatEventDateTime } from '@src/packages/events/components/TimelineEvent/utils/mapTimelineEventPresentation';

export interface SearchResultLabels {
  title: string;
  details: string[];
}

const buildDetails = (startAtMs: number | null, divisionName?: string): string[] =>
  [startAtMs != null ? formatEventDateTime(startAtMs) : '', divisionName?.trim() ?? ''].filter(
    Boolean,
  );

/** Row labels for a schedule or route hit; the index only carries the division id. */
export const getScheduleSearchResultLabels = (
  schedule: ScheduleSearchSummary,
  divisionName?: string,
): SearchResultLabels => ({
  title: schedule.name,
  details: buildDetails(schedule.startAtMs, divisionName),
});

export const getTaskSearchResultLabels = (task: ExecutionSearchSummary): SearchResultLabels => ({
  title: task.scheduleName,
  details: buildDetails(task.startAtMs, task.division.name),
});
